import React from "react";
import { Container, Row, Col } from "reactstrap";

class HeaderPage extends React.Component
{
    render()
    {
        return (
        <>
            <div className="header-filter pt-6 pb-4" style={{
            minHeight: "20vh",
            backgroundImage: "url(" + require("assets/img/backgrounds/page-header-bg-1.jpg") + ")",
            backgroundSize: "cover"
            }}>
            <Container>
                <Row>
                <Col className="text-left">
                    <h2 className="display-2 g-font-kanit pb-0 mb-0 ml-0" style={{
                    fontSize: "2.5em",
                    color: "#444",
                    paddingLeft: "0em"
                    }}>
                    {this.props.pageTitle}
                    </h2>
                    <p className={"g-font-sarabun mt-0 pt-0"} style={{
                        fontSize: "20px",
                        fontWeight: "200",
                        color: "black"
                    }}>
                    {this.props.pageSubtitle}
                    </p>
                </Col>
                </Row>
            </Container>
            </div>
        </>
        )
    }
}

export default HeaderPage;
